// 模拟数据文件
export const mockData = {
  // 多语言配置
  translations: {
    zh: {
      nav: { home: '首页', cars: '精选车型', categories: '品牌分类', about: '关于我们' },
      sections: {
        featured: '精选车型', featuredDesc: '严选优质二手车，每辆车均经过专业检测',
        categories: '车型分类', categoriesDesc: '按类型快速筛选，精准定位心仪车型'
      },
      car: {
        year: '年',
        kilometers: '万公里',
        priceUnit: '万'
      },
      services: {
        professionalInspection: {
          title: '专业检测',
          desc: '152项专业检测标准，全面评估车辆状况'
        },
        tradeGuarantee: {
          title: '交易保障',
          desc: '第三方托管交易，确保买卖双方权益'
        },
        transferService: {
          title: '过户服务',
          desc: '一站式过户服务，省心快捷'
        },
        afterSales: {
          title: '售后保障',
          desc: '365天售后保障，随时为您服务'
        }
      },
      footer: {
        aboutUs: '关于我们',
        companyIntro: '公司介绍',
        contactUs: '联系我们',
        privacy: '隐私政策',
        terms: '使用条款',
        contactInfo: '联系方式',
        phone: '400-888-8888',
        email: 'service@carmarket.com',
        address: '北京市朝阳区xxx路xxx号'
      },
      search: { placeholder: '搜索品牌、型号...' },
      sort: {
        price_asc: '价格从低到高',
        price_desc: '价格从高到低',
        condition_desc: '新旧程度最高',
        condition_asc: '新旧程度最低',
        distance_asc: '距离最近',
        year_desc: '年份最新'
      }
    },
    en: {
      nav: { home: 'Home', cars: 'Featured Cars', categories: 'Categories', about: 'About Us' },
      sections: {
        featured: 'Featured Cars', featuredDesc: 'Carefully selected used cars, each professionally inspected',
        categories: 'Car Categories', categoriesDesc: 'Filter by type, find your perfect car quickly'
      },
      car: {
        year: '',
        kilometers: ' km',
        priceUnit: 'K'
      },
      services: {
        professionalInspection: {
          title: 'Professional Inspection',
          desc: '152 professional inspection standards, comprehensive vehicle condition assessment'
        },
        tradeGuarantee: {
          title: 'Trade Guarantee',
          desc: 'Third-party escrow transaction to protect the rights of both buyers and sellers'
        },
        transferService: {
          title: 'Transfer Service',
          desc: 'One-stop transfer service, worry-free and fast'
        },
        afterSales: {
          title: 'After-sales Support',
          desc: '365 days after-sales support, always at your service'
        }
      },
      footer: {
        aboutUs: 'About Us',
        companyIntro: 'Company Introduction',
        contactUs: 'Contact Us',
        privacy: 'Privacy Policy',
        terms: 'Terms of Use',
        contactInfo: 'Contact Information',
        phone: '400-888-8888',
        email: 'service@carmarket.com',
        address: 'Chaoyang District, Beijing xxx Road xxx Number'
      },
      search: { placeholder: 'Search brand, model...' },
      sort: {
        price_asc: 'Price: Low to High',
        price_desc: 'Price: High to Low',
        condition_desc: 'Best Condition First',
        condition_asc: 'Worst Condition First',
        distance_asc: 'Nearest Distance',
        year_desc: 'Newest Year'
      }
    },
    ru: {
      nav: { home: 'Главная', cars: 'Рекомендуемые автомобили', categories: 'Категории', about: 'О нас' },
      sections: {
        featured: 'Рекомендуемые автомобили', featuredDesc: 'Тщательно отобранные подержанные автомобили, каждый прошел профессиональную проверку',
        categories: 'Категории автомобилей', categoriesDesc: 'Фильтр по типу, быстро найдите свой идеальный автомобиль'
      },
      car: {
        year: ' г.',
        kilometers: ' км',
        priceUnit: ' млн'
      },
      services: {
        professionalInspection: {
          title: 'Профессиональная проверка',
          desc: '152 стандарта профессиональной проверки, комплексная оценка состояния автомобиля'
        },
        tradeGuarantee: {
          title: 'Гарантия сделки',
          desc: 'Сделка через третью сторону для защиты прав покупателя и продавца'
        },
        transferService: {
          title: 'Услуга перерегистрации',
          desc: 'Комплексная услуга перерегистрации, удобная и быстрая'
        },
        afterSales: {
          title: 'Послепродажная поддержка',
          desc: '365 дней послепродажной поддержки, всегда к вашим услугам'
        }
      },
      footer: {
        aboutUs: 'О нас',
        companyIntro: 'О компании',
        contactUs: 'Связаться с нами',
        privacy: 'Политика конфиденциальности',
        terms: 'Условия использования',
        contactInfo: 'Контактная информация',
        phone: '400-888-8888',
        email: 'service@carmarket.com',
        address: 'Чаоян район, Пекин ул.xxx д.xxx'
      },
      search: { placeholder: 'Поиск бренда, модели...' },
      sort: {
        price_asc: 'Цена: по возрастанию',
        price_desc: 'Цена: по убыванию',
        condition_desc: 'Лучшее состояние',
        condition_asc: 'Худшее состояние',
        distance_asc: 'Ближайшее расстояние',
        year_desc: 'Самый новый год'
      }
    }
  },
  // 城市数据
  cities: [
    {
      code: 'beijing',
      translations: {
        zh: { name: '北京' },
        en: { name: 'Beijing' },
        ru: { name: 'Пекин' }
      }
    },
    {
      code: 'shanghai',
      translations: {
        zh: { name: '上海' },
        en: { name: 'Shanghai' },
        ru: { name: 'Шанхай' }
      }
    },
    {
      code: 'guangzhou',
      translations: {
        zh: { name: '广州' },
        en: { name: 'Guangzhou' },
        ru: { name: 'Гуанчжоу' }
      }
    },
    {
      code: 'shenzhen',
      translations: {
        zh: { name: '深圳' },
        en: { name: 'Shenzhen' },
        ru: { name: 'Шэньчжэнь' }
      }
    },
    {
      code: 'hangzhou',
      translations: {
        zh: { name: '杭州' },
        en: { name: 'Hangzhou' },
        ru: { name: 'Ханчжоу' }
      }
    },
    {
      code: 'chengdu',
      translations: {
        zh: { name: '成都' },
        en: { name: 'Chengdu' },
        ru: { name: 'Чэнду' }
      }
    },
    {
      code: 'nanjing',
      translations: {
        zh: { name: '南京' },
        en: { name: 'Nanjing' },
        ru: { name: 'Нанкин' }
      }
    },
    {
      code: 'wuhan',
      translations: {
        zh: { name: '武汉' },
        en: { name: 'Wuhan' },
        ru: { name: 'Ухань' }
      }
    },
    {
      code: 'xian',
      translations: {
        zh: { name: '西安' },
        en: { name: 'Xi\'an' },
        ru: { name: 'Сиань' }
      }
    },
    {
      code: 'tianjin',
      translations: {
        zh: { name: '天津' },
        en: { name: 'Tianjin' },
        ru: { name: 'Тяньцзинь' }
      }
    }
  ],

  // 汽车品牌数据（包含logo）
  brands: [
    {
      id: 1,
      logo: 'https://logos-world.net/wp-content/uploads/2021/04/Mercedes-Benz-Logo.png',
      count: 156,
      category: 'luxury',
      translations: {
        zh: { name: '奔驰' },
        en: { name: 'Mercedes-Benz' },
        ru: { name: 'Mercedes-Benz' }
      }
    },
    {
      id: 2,
      logo: 'https://logos-world.net/wp-content/uploads/2020/04/BMW-Logo-2020-present.jpg',
      count: 142,
      category: 'luxury',
      translations: {
        zh: { name: '宝马' },
        en: { name: 'BMW' },
        ru: { name: 'BMW' }
      }
    },
    {
      id: 3,
      logo: 'https://logos-world.net/wp-content/uploads/2021/04/Audi-Logo.png',
      count: 138,
      category: 'luxury',
      translations: {
        zh: { name: '奥迪' },
        en: { name: 'Audi' },
        ru: { name: 'Audi' }
      }
    },
    {
      id: 4,
      logo: 'https://logos-world.net/wp-content/uploads/2021/04/Tesla-Logo.png',
      count: 89,
      category: 'electric',
      translations: {
        zh: { name: '特斯拉' },
        en: { name: 'Tesla' },
        ru: { name: 'Tesla' }
      }
    },
    {
      id: 5,
      logo: 'https://logos-world.net/wp-content/uploads/2021/04/Honda-Logo.png',
      count: 203,
      category: 'family',
      translations: {
        zh: { name: '本田' },
        en: { name: 'Honda' },
        ru: { name: 'Honda' }
      }
    },
    {
      id: 6,
      logo: 'https://logos-world.net/wp-content/uploads/2020/04/Toyota-Symbol.png',
      count: 187,
      category: 'family',
      translations: {
        zh: { name: '丰田' },
        en: { name: 'Toyota' },
        ru: { name: 'Toyota' }
      }
    },
    {
      id: 7,
      logo: 'https://logos-world.net/wp-content/uploads/2021/04/Volkswagen-Logo.png',
      count: 245,
      category: 'family',
      translations: {
        zh: { name: '大众' },
        en: { name: 'Volkswagen' },
        ru: { name: 'Volkswagen' }
      }
    },
    {
      id: 8,
      logo: 'https://logos-world.net/wp-content/uploads/2021/04/Porsche-Logo.png',
      count: 67,
      category: 'sports',
      translations: {
        zh: { name: '保时捷' },
        en: { name: 'Porsche' },
        ru: { name: 'Porsche' }
      }
    },
    {
      id: 9,
      logo: 'https://logos-world.net/wp-content/uploads/2021/09/Land-Rover-Logo.jpg',
      count: 94,
      category: 'suv',
      translations: {
        zh: { name: '路虎' },
        en: { name: 'Land Rover' },
        ru: { name: 'Land Rover' }
      }
    },
    {
      id: 10,
      logo: 'https://logos-world.net/wp-content/uploads/2021/04/Cadillac-Logo.png',
      count: 76,
      category: 'luxury',
      translations: {
        zh: { name: '凯迪拉克' },
        en: { name: 'Cadillac' },
        ru: { name: 'Cadillac' }
      }
    },
    {
      id: 11,
      logo: 'https://logos-world.net/wp-content/uploads/2021/09/Lexus-Logo.png',
      count: 58,
      category: 'luxury',
      translations: {
        zh: { name: '雷克萨斯' },
        en: { name: 'Lexus' },
        ru: { name: 'Lexus' }
      }
    }
  ],

  // 车辆类型
  vehicleTypes: [
    {
      id: 1,
      code: 'sedan',
      count: 856,
      icon: 'el-icon-present',
      translations: {
        zh: { name: '轿车' },
        en: { name: 'Sedan' },
        ru: { name: 'Седан' }
      }
    },
    {
      id: 2,
      code: 'suv',
      count: 423,
      icon: 'el-icon-truck',
      translations: {
        zh: { name: 'SUV' },
        en: { name: 'SUV' },
        ru: { name: 'SUV' }
      }
    },
    {
      id: 3,
      code: 'electric',
      count: 156,
      icon: 'el-icon-lightning',
      translations: {
        zh: { name: '新能源车' },
        en: { name: 'Electric Vehicles' },
        ru: { name: 'Электромобили' }
      }
    },
    {
      id: 4,
      code: 'family',
      count: 634,
      icon: 'el-icon-s-home',
      translations: {
        zh: { name: '家用轿车' },
        en: { name: 'Family Sedan' },
        ru: { name: 'Семейный седан' }
      }
    },
    {
      id: 5,
      code: 'sports',
      count: 89,
      icon: 'el-icon-s-flag',
      translations: {
        zh: { name: '跑车' },
        en: { name: 'Sports Car' },
        ru: { name: 'Спорткар' }
      }
    },
    {
      id: 6,
      code: 'mpv',
      count: 142,
      icon: 'el-icon-office-building',
      translations: {
        zh: { name: 'MPV' },
        en: { name: 'MPV' },
        ru: { name: 'MPV' }
      }
    }
  ],

  // 价格区间
  priceRanges: [
    {
      id: 1,
      min: 0,
      max: 5,
      count: 89,
      translations: {
        zh: { name: '5万以内' },
        en: { name: 'Under 50K' },
        ru: { name: 'До 500 тыс.' }
      }
    },
    {
      id: 2,
      min: 5,
      max: 15,
      count: 234,
      translations: {
        zh: { name: '5-15万' },
        en: { name: '50K-150K' },
        ru: { name: '500 тыс.-1.5 млн.' }
      }
    },
    {
      id: 3,
      min: 15,
      max: 25,
      count: 345,
      translations: {
        zh: { name: '15-25万' },
        en: { name: '150K-250K' },
        ru: { name: '1.5-2.5 млн.' }
      }
    },
    {
      id: 4,
      min: 25,
      max: 40,
      count: 198,
      translations: {
        zh: { name: '25-40万' },
        en: { name: '250K-400K' },
        ru: { name: '2.5-4 млн.' }
      }
    },
    {
      id: 5,
      min: 40,
      max: 60,
      count: 156,
      translations: {
        zh: { name: '40-60万' },
        en: { name: '400K-600K' },
        ru: { name: '4-6 млн.' }
      }
    },
    {
      id: 6,
      min: 60,
      max: 999,
      count: 67,
      translations: {
        zh: { name: '60万以上' },
        en: { name: 'Over 600K' },
        ru: { name: 'Свыше 6 млн.' }
      }
    }
  ],

  // 车辆数据
  vehicles: [
    {
      id: 1,
      brand: '奔驰',
      brandId: 1,
      year: '2018',
      mileage: '6.8',
      condition: '8成新', // 新增：几成新
      price: '28.8',
      originalPrice: '32',
      location: '北京',
      distance: '2.3km',
      image: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?w=400&h=300&fit=crop&auto=format',
      badge: '超值',
      categoryId: 1,
      type: 'sedan',
      features: ['2.0T发动机', '自动挡', '全景天窗', '真皮座椅', '导航系统'],
      isFavorite: false,
      translations: {
        zh: {
          name: '奔驰C级 C260L',
          description: '豪华轿车典范，外观时尚，动力充沛，驾驶舒适'
        },
        en: {
          name: 'Mercedes-Benz C-Class C260L',
          description: 'Luxury sedan benchmark, stylish appearance, powerful performance, comfortable driving'
        },
        ru: {
          name: 'Mercedes-Benz C-Class C260L',
          description: 'Эталон роскошного седана, стильный дизайн, мощная производительность, комфортная езда'
        }
      }
    },
    {
      id: 2,
      brand: '宝马',
      brandId: 2,
      year: '2019',
      mileage: '4.2',
      condition: '9成新', // 新增：几成新
      price: '32.5',
      location: '上海',
      distance: '1.8km',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop&auto=format',
      badge: '精品',
      categoryId: 1,
      type: 'sedan',
      features: ['2.0T发动机', '运动模式', 'LED大灯', '倒车影像', '智能互联'],
      isFavorite: false,
      translations: {
        zh: {
          name: '宝马3系 320i',
          description: '运动轿车经典之作，操控精准，科技感强'
        },
        en: {
          name: 'BMW 3 Series 320i',
          description: 'Sports sedan classic, precise handling, strong technology'
        },
        ru: {
          name: 'BMW 3 Series 320i',
          description: 'Классика спортивного седана, точное управление, сильная технология'
        }
      }
    },
    {
      id: 3,
      brand: '奥迪',
      brandId: 3,
      year: '2017',
      mileage: '8.1',
      condition: '7成新', // 新增：几成新
      price: '25.9',
      originalPrice: '29',
      location: '深圳',
      distance: '3.1km',
      image: 'https://images.unsplash.com/photo-1603584173870-7f23fdae1b7a?w=400&h=300&fit=crop&auto=format',
      badge: '热销',
      categoryId: 1,
      type: 'sedan',
      features: ['2.0T发动机', '全景天窗', '电动座椅', '定速巡航', '多功能方向盘'],
      isFavorite: false,
      translations: {
        zh: {
          name: '奥迪A4L 40TFSI',
          description: '豪华商务轿车，空间宽敞，配置丰富'
        },
        en: {
          name: 'Audi A4L 40TFSI',
          description: 'Luxury business sedan, spacious interior, rich configuration'
        },
        ru: {
          name: 'Audi A4L 40TFSI',
          description: 'Роскошный бизнес-седан, просторный салон, богатая комплектация'
        }
      }
    },
    {
      id: 4,
      brand: '特斯拉',
      brandId: 4,
      year: '2020',
      mileage: '3.5',
      condition: '9.5成新', // 新增：几成新
      price: '35.8',
      location: '杭州',
      distance: '4.2km',
      image: 'https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=400&h=300&fit=crop&auto=format',
      badge: '新能源',
      categoryId: 3,
      type: 'electric',
      features: ['电动机', '自动驾驶', '大屏中控', 'OTA升级', '超快充电'],
      isFavorite: false,
      translations: {
        zh: {
          name: '特斯拉Model 3 长续航',
          description: '智能电动轿车，续航里程长，驾驶平顺'
        },
        en: {
          name: 'Tesla Model 3 Long Range',
          description: 'Smart electric sedan, long range, leading technology configuration'
        },
        ru: {
          name: 'Tesla Model 3 Long Range',
          description: 'Умный электромобиль, большой запас хода, передовые технологии'
        }
      }
    },
    {
      id: 5,
      brand: '本田',
      brandId: 5,
      year: '2019',
      mileage: '5.6',
      condition: '8.5成新', // 新增：几成新
      price: '12.8',
      location: '广州',
      distance: '2.7km',
      image: 'https://images.unsplash.com/photo-1609951651556-5334e2706168?w=400&h=300&fit=crop&auto=format',
      badge: 'SUV',
      categoryId: 2,
      type: 'suv',
      features: ['1.5T发动机', 'CVT变速箱', 'LED大灯', '多媒体系统', '全景影像'],
      isFavorite: false,
      translations: {
        zh: {
          name: '本田XR-V 1.5T',
          description: '都市SUV，空间实用，油耗经济'
        },
        en: {
          name: 'Honda XR-V 1.5T',
          description: 'Urban SUV, practical space, economical fuel consumption'
        },
        ru: {
          name: 'Honda XR-V 1.5T',
          description: 'Городской SUV, практичное пространство, экономичный расход топлива'
        }
      }
    },
    {
      id: 6,
      brand: '大众',
      brandId: 7,
      year: '2018',
      mileage: '7.2',
      condition: '7.5成新', // 新增：几成新
      price: '10.9',
      location: '南京',
      distance: '1.5km',
      image: 'https://images.unsplash.com/photo-1603584173870-7f23fdae1b7a?w=400&h=300&fit=crop&auto=format',
      badge: '家用',
      categoryId: 4,
      type: 'family',
      features: ['1.6L发动机', '手动挡', '空调系统', 'ABS防抱死', '多功能方向盘'],
      isFavorite: false,
      translations: {
        zh: {
          name: '大众朗逸 1.6L',
          description: '德系家轿代表，质量可靠，维修便捷'
        },
        en: {
          name: 'Volkswagen Lavida 1.6L',
          description: 'German sedan representative, reliable quality, convenient maintenance'
        },
        ru: {
          name: 'Volkswagen Lavida 1.6L',
          description: 'Представитель немецкого седана, надежное качество, удобное обслуживание'
        }
      }
    },
    {
      id: 7,
      brand: '保时捷',
      brandId: 8,
      year: '2021',
      mileage: '1.2',
      condition: '9.8成新', // 新增：几成新
      price: '158',
      location: '深圳',
      distance: '5.6km',
      image: 'https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=400&h=300&fit=crop&auto=format',
      badge: '豪华',
      categoryId: 5,
      type: 'sports',
      features: ['3.0T发动机', '双涡轮', '碳纤维车身', '陶瓷刹车', '运动悬挂'],
      isFavorite: false,
      translations: {
        zh: {
          name: '保时捷911 Carrera',
          description: '跑车中的传奇，性能卓越，设计经典'
        },
        en: {
          name: 'Porsche 911 Carrera',
          description: 'Legendary sports car, excellent performance, classic design'
        },
        ru: {
          name: 'Porsche 911 Carrera',
          description: 'Легендарный спорткар, превосходная производительность, классический дизайн'
        }
      }
    },
    {
      id: 8,
      brand: '丰田',
      brandId: 6,
      year: '2019',
      mileage: '6.8',
      condition: '8成新', // 新增：几成新
      price: '45.8',
      location: '北京',
      distance: '3.8km',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop&auto=format',
      badge: 'MPV',
      categoryId: 6,
      type: 'mpv',
      features: ['2.5L发动机', '电动侧滑门', '真皮座椅', '全景天窗', '后排娱乐'],
      isFavorite: false,
      translations: {
        zh: {
          name: '丰田埃尔法',
          description: '豪华MPV，空间宽敞，乘坐舒适'
        },
        en: {
          name: 'Toyota Alphard',
          description: 'Luxury MPV, spacious interior, comfortable seating'
        },
        ru: {
          name: 'Toyota Alphard',
          description: 'Роскошный MPV, просторный салон, комфортные сиденья'
        }
      }
    }
  ],

  // 轮播图数据
  carouselImages: [
    {
      id: 1,
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=500&fit=crop&auto=format',
      translations: {
        zh: {
          title: '精品二手车',
          subtitle: '严格检测 · 品质保证',
          buttonText: '立即选车'
        },
        en: {
          title: 'Premium Used Cars',
          subtitle: 'Strict Inspection · Quality Assurance',
          buttonText: 'Browse Cars'
        },
        ru: {
          title: 'Премиум автомобили',
          subtitle: 'Строгая проверка · Гарантия качества',
          buttonText: 'Выбрать автомобиль'
        }
      }
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?w=800&h=500&fit=crop&auto=format',
      translations: {
        zh: {
          title: '专业评估',
          subtitle: '免费上门 · 精准报价',
          buttonText: '免费评估'
        },
        en: {
          title: 'Professional Assessment',
          subtitle: 'Free Home Service · Accurate Pricing',
          buttonText: 'Free Assessment'
        },
        ru: {
          title: 'Профессиональная оценка',
          subtitle: 'Бесплатно на дому · Точная цена',
          buttonText: 'Бесплатная оценка'
        }
      }
    },
    {
      id: 3,
      image: 'https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=800&h=500&fit=crop&auto=format',
      translations: {
        zh: {
          title: '新能源专区',
          subtitle: '绿色出行 · 科技体验',
          buttonText: '查看新能源'
        },
        en: {
          title: 'Electric Vehicles Zone',
          subtitle: 'Green Travel · Technology Experience',
          buttonText: 'View Electric Cars'
        },
        ru: {
          title: 'Зона электромобилей',
          subtitle: 'Зеленый транспорт · Технологии',
          buttonText: 'Посмотреть электромобили'
        }
      }
    }
  ],

  // 排序选项

  // 统计数据
  stats: {
    totalCars: '5000+',
    satisfaction: '98%',
    warranty: '365天',
    experience: '8',
    transactions: '25000+',
    certification: '15项'
  },

  // 服务保障
  services: [
    {
      id: 1,
      icon: 'el-icon-s-check',
      translations: {
        zh: {
          title: '专业检测',
          desc: '152项专业检测标准，全面评估车辆状况'
        },
        en: {
          title: 'Professional Inspection',
          desc: '152 professional inspection standards, comprehensive vehicle condition assessment'
        },
        ru: {
          title: 'Профессиональная проверка',
          desc: '152 стандарта профессиональной проверки, комплексная оценка состояния автомобиля'
        }
      }
    },
    {
      id: 2,
      icon: 'el-icon-s-custom',
      translations: {
        zh: {
          title: '交易保障',
          desc: '第三方托管交易，确保买卖双方权益'
        },
        en: {
          title: 'Trade Guarantee',
          desc: 'Third-party escrow transaction to protect the rights of both buyers and sellers'
        },
        ru: {
          title: 'Гарантия сделки',
          desc: 'Сделка через третью сторону для защиты прав покупателя и продавца'
        }
      }
    },
    {
      id: 3,
      icon: 'el-icon-document-copy',
      translations: {
        zh: {
          title: '过户服务',
          desc: '一站式过户服务，省心快捷'
        },
        en: {
          title: 'Transfer Service',
          desc: 'One-stop transfer service, worry-free and fast'
        },
        ru: {
          title: 'Услуга перерегистрации',
          desc: 'Комплексная услуга перерегистрации, удобная и быстрая'
        }
      }
    },
    {
      id: 4,
      icon: 'el-icon-service',
      translations: {
        zh: {
          title: '售后保障',
          desc: '365天售后保障，随时为您服务'
        },
        en: {
          title: 'After-sales Support',
          desc: '365 days after-sales support, always at your service'
        },
        ru: {
          title: 'Послепродажная поддержка',
          desc: '365 дней послепродажной поддержки, всегда к вашим услугам'
        }
      }
    }
  ]
};

// 获取当前语言的翻译工具函数
export const getText = (path, lang = 'zh') => {
  try {
    const keys = path.split('.');
    let value = mockData.translations[lang];

    for (const key of keys) {
      value = value && value[key];
    }

    if (value === undefined || value === null) {
      console.warn(`Translation key "${path}" not found for language ${lang}`);
      // 返回默认值
      if (path === 'car.year') return lang === 'zh' ? '年' : lang === 'ru' ? ' г.' : '';
      if (path === 'car.kilometers') return lang === 'zh' ? '万公里' : lang === 'ru' ? ' км' : ' km';
      if (path === 'car.priceUnit') return lang === 'zh' ? '万' : lang === 'ru' ? ' млн' : 'K';
      return path;
    }

    return value;
  } catch (error) {
    console.warn(`Error getting translation for "${path}":`, error);
    return path;
  }
};

// 获取多语言数据的工具函数
export const getLocalizedData = (data, lang = 'zh') => {
  if (!data) return data;

  // 如果数据有 translations 字段，使用对应语言的翻译
  if (data.translations && data.translations[lang]) {
    return { ...data, ...data.translations[lang] };
  }

  // 如果数据是数组，递归处理每个元素
  if (Array.isArray(data)) {
    return data.map(item => getLocalizedData(item, lang));
  }

  // 如果数据是对象，递归处理每个属性
  if (typeof data === 'object') {
    const result = {};
    for (const key in data) {
      if (key !== 'translations') {
        result[key] = getLocalizedData(data[key], lang);
      }
    }
    return result;
  }

  return data;
};

export default mockData;

